<template>
  <div class="bg-gradient-primary">
    <div class="container">
      <br>

      <div class="card o-hidden border-0 shadow-lg">
        <div class="card-body p-0">
          <div class="row" style="min-height: 60vh">
            <div class="col-lg-5 d-none d-lg-block bg-register-image"></div>
            <div class="col-lg-7 my-auto">
              <div class="p-4">
                <div class="text-center">
                  <img class="logo mx-1 my-1" src="@/assets/lion.png"/>
                  <h4 class="mb-sm-2 mb-md-4">Passwortvergabe / Passwort vergessen?</h4>
                </div>
                <br>
                <form v-if="modus === 0" class="user" v-on:submit.prevent="onSubmit">
                  <div>
                    <div class="form-group">
                      <input v-model="userData.sEmail" type="text" class="form-control form-control-user"
                             placeholder="E-Mail Adresse">
                    </div>
                  </div>
                  <br>
                  <button type="submit" class="btn btn-primary btn-user btn-block">Link zusenden
                  </button>
                </form>
                <br>
                <div v-if="modus===1" class="text-center">
                  <h5>Passwort wird zurückgesetzt.</h5>
                  <br>
                  Sie erhalten in Kürze eine E-Mail mit einem Änderungslink.
                  <br><br>Das Passwort muss innerhalb von 24 Stunden geändert werden. Danach wird der Link automatisch
                  ungültig.<br>
                  <br> <br> <br>
                </div>
                <hr>
                <div class="text-center">
                  <router-link class="small" to="/login">Zum Login</router-link>
                </div>
                <div class="text-center">
                  <router-link class="small" to="/datenschutzPublic">Impressum & Datenschutzhinweise</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <img class="logo-lg" src="@/assets/findSolutions-trans.png"/>
    </div>
  </div>
</template>

<script>
import UserRegisterService from '../services/UserRegisterService'

export default {
  components: {},
  async mounted () {

  },
  data () {
    return {
      modus: 0,
      userData: {
        sEmail: ''
      }
    }
  },
  methods: {
    onSubmit () {
      UserRegisterService.passwordForgotten(this.userData)
        .then(response => {
          this.modus = 1
        })
        .catch(e => {
          this.$alert('Fehler! Bitte E-Mail-Adresse prüfen und erneut versuchen!')
        })
    }
  },
  computed: {}
}
</script>

<style>
</style>
